module.exports = __webpack_public_path__ + "img/protection.2f055147.jpeg";